import PropTypes from 'prop-types';
import './PaymentsSummary.css';

const PaymentsSummary = ({ summary, loading }) => {
  if (loading) {
    return (
      <div className="payments-summary-skeleton">
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
      </div>
    );
  }

  if (!summary) {
    return null;
  }

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '$0.00';
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(amount);
  };

  const stats = [
    {
      label: 'Total Transactions',
      value: summary.totalTransactions || 0,
      color: 'primary'
    },
    {
      label: 'Total Amount',
      value: formatCurrency(summary.totalAmount),
      color: 'success'
    },
    {
      label: 'Completed',
      value: summary.completedCount || 0,
      color: 'info'
    },
    {
      label: 'Pending',
      value: summary.pendingCount || 0,
      color: 'warning'
    },
    {
      label: 'Failed',
      value: summary.failedCount || 0,
      color: 'danger'
    },
    {
      label: 'Average Amount',
      value: formatCurrency(summary.averageAmount),
      color: 'secondary'
    }
  ];

  return (
    <div className="payments-summary">
      <div className="summary-grid">
        {stats.map((stat, index) => (
          <div key={index} className={`summary-card bg-${stat.color}`}>
            <div className="summary-label">{stat.label}</div>
            <div className="summary-value">{stat.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

PaymentsSummary.propTypes = {
  summary: PropTypes.shape({
    totalTransactions: PropTypes.number,
    totalAmount: PropTypes.number,
    completedCount: PropTypes.number,
    pendingCount: PropTypes.number,
    failedCount: PropTypes.number,
    averageAmount: PropTypes.number
  }),
  loading: PropTypes.bool
};

export default PaymentsSummary;
